const NotScheduledOrNotNeeded = () => {
  return (
    <svg
      aria-hidden="true"
      width="10"
      height="2"
      viewBox="0 0 10 2"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9 2C9.55312 2 10 1.55313 10 1C10 0.446875 9.55313 -1.95335e-08 9 -4.37114e-08L1 -3.93402e-07C0.446876 -4.1758e-07 -1.95335e-08 0.446875 -4.37114e-08 1C-6.78893e-08 1.55312 0.446875 2 1 2L9 2Z"
        fill="#999999"
      />
    </svg>
  )
}

export default NotScheduledOrNotNeeded
